import React, { useState } from 'react';
import { UrlDataProvider } from './lib/UrlDataContext';
import { Header } from './elements/Header';
import { CurrentUrlData } from './elements/CurrentUrlData';
import { MatchOrCreateProduct } from './elements/MatchOrCreateProduct';
import { Filters } from './elements/Filters';
import { IgnoredDomainsModal } from './elements/IgnoredDomainsModal';
import { ActionProvider } from './lib/ActionContext';
import './UrlData.scss';

const UrlData = () => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [ignoredDomainsModalOpen, setIgnoredDomainsModalOpen] = useState(false);

  return (
    <div className='url-data-container'>
      <UrlDataProvider>
        <Header onSearchPressed={() => setFiltersOpen(prev => !prev)} />

        <div className='content-container'>
          {filtersOpen && (
            <div className='filters-pane'>
              <Filters onRequestClose={() => setFiltersOpen(false)} onOpenIgnoredDomains={() => setIgnoredDomainsModalOpen(true)} />
            </div>
          )}

          <div className='left-pane'>
            <CurrentUrlData />
          </div>

          <div className='right-pane'>
            <ActionProvider>
              <MatchOrCreateProduct />
            </ActionProvider>
          </div>
        </div>

        <IgnoredDomainsModal isOpen={ignoredDomainsModalOpen} onClose={() => setIgnoredDomainsModalOpen(false)} />
      </UrlDataProvider>
    </div>
  );
};

export default UrlData;
